var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{class:{'text-center': _vm.centered}},[_c('default-button',{attrs:{"dare_colors":_vm.dare_colors,"href":_vm.button_link}},[_vm._v("\n      "+_vm._s(_vm.button_text)+"\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }